import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';
import messages from '../../../i18n/en';
import { asyncLanguages } from './async-languages';
var fetchMessagesForLocale = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var _asyncLanguages$langu, _localeMessages$defau, languageLocale, localeMessages;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          // Fallback to the generic locale if specified one is not found
          languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || ''; // Dynamic import of the locale file
          _context.next = 4;
          return (_asyncLanguages$langu = asyncLanguages[languageLocale]) === null || _asyncLanguages$langu === void 0 ? void 0 : _asyncLanguages$langu.call(asyncLanguages);
        case 4:
          localeMessages = _context.sent;
          return _context.abrupt("return", (_localeMessages$defau = localeMessages === null || localeMessages === void 0 ? void 0 : localeMessages.default) !== null && _localeMessages$defau !== void 0 ? _localeMessages$defau : messages);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
        case 10:
          return _context.abrupt("return", messages);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function fetchMessagesForLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var CommerceIntlProvider = function CommerceIntlProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(IntlMessagesProvider, {
    defaultMessages: messages,
    loaderFn: fetchMessagesForLocale
  }, children);
};